import { useEffect } from 'react';

export const CONTACT_TITLE = 'Contact — MUTATIO618';
export const CONTACT_DESCRIPTION =
  'Contact MUTATIO618 — Reach us with questions, partnership inquiries, or to begin your transformation journey.';

function meta(selector: string): HTMLMetaElement | null {
  return document.head.querySelector<HTMLMetaElement>(selector);
}

/** The Contact page's document title and description (and their Open Graph twins), restored on leave. */
export function useContactMeta(): void {
  useEffect(() => {
    const description = meta('meta[name="description"]');
    const ogTitle = meta('meta[property="og:title"]');
    const ogDescription = meta('meta[property="og:description"]');
    const previous = {
      title: document.title,
      description: description?.content,
      ogTitle: ogTitle?.content,
      ogDescription: ogDescription?.content,
    };
    document.title = CONTACT_TITLE;
    if (description) description.content = CONTACT_DESCRIPTION;
    if (ogTitle) ogTitle.content = CONTACT_TITLE;
    if (ogDescription) ogDescription.content = CONTACT_DESCRIPTION;
    return () => {
      document.title = previous.title;
      if (description && previous.description !== undefined) description.content = previous.description;
      if (ogTitle && previous.ogTitle !== undefined) ogTitle.content = previous.ogTitle;
      if (ogDescription && previous.ogDescription !== undefined) ogDescription.content = previous.ogDescription;
    };
  }, []);
}
